import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/payment-methods/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddContactModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function SalesStatusList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Sales Status" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Sales Status</h5>
      </div>

      <CrudProvider>
        <SalesStatusTable />
      </CrudProvider>
    </>
  )
}

function SalesStatusTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Sales Status"
        columns={columns}
        apiPath="settings"
        hardcodedFilters={{ key: "sales-status" }}
        revalidateQuery="sales-status"
      />

      {openDialog ? <AddContactModal routeKey="sales-status" /> : null}
    </>
  )
}
